/**
 * jc-logo.tsx — the JumpCannon lockup, ported from the design system's
 * components/brand/Logo.jsx (JumpCannon Design System, 28 Sep 2026): the
 * four-dot Sequence mark and the live Spectral wordmark "JumpCannon" with an
 * Ionosphere dot on paper. The geometry and colours are the design system's;
 * it is a placeholder there until official logo files land, and so it is here.
 */
const SEQ: [number, number, number][] = [
  [20, 96, 9],
  [86, 79, 12],
  [148, 45, 15],
  [204, 18, 18],
];
const THEMES = {
  light: {
    dots: ["#584D43", "#3B5BDB", "#E8A33D", "#E8A33D"],
    word: "#14182B",
  },
  dark: {
    dots: ["#D8DCEC", "#3B5BDB", "#E8A33D", "#E8A33D"],
    word: "#FAF7F0",
  },
} as const;

export function JcLogo({
  theme = "light",
  size = 24,
}: {
  theme?: keyof typeof THEMES;
  size?: number;
}) {
  const t = THEMES[theme];
  const markH = Math.round(size * 0.84);
  return (
    <span
      role="img"
      aria-label="JumpCannon"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: Math.round(size * 0.42),
      }}
    >
      <svg
        width={(markH * 220) / 120}
        height={markH}
        viewBox="0 0 220 120"
        fill="none"
        aria-hidden="true"
        style={{ flex: "none", display: "block" }}
      >
        {SEQ.map(([cx, cy, r], i) => (
          <circle key={i} cx={cx} cy={cy} r={r} fill={t.dots[i]} />
        ))}
      </svg>
      <span
        aria-hidden="true"
        style={{
          fontFamily: "var(--font-serif)",
          fontWeight: 600,
          fontSize: size,
          letterSpacing: "-0.01em",
          color: t.word,
          lineHeight: 1,
          whiteSpace: "nowrap",
        }}
      >
        {/* Rayna, 28 Sep: the wordmark drops its period */}
        JumpCannon
      </span>
    </span>
  );
}
